import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react'

const B = 'https://pixner.net/bankio/main/assets/images'

const cols = [
  {
    title: 'Company',
    links: [
      { label: 'About Us', to: '/about-us' },
      { label: 'Pricing', to: '/pricing' },
      { label: 'FAQ', to: '/faq' },
    ],
  },
  {
    title: 'Services',
    links: [
      { label: 'Software Development', to: '/services/software-development' },
      { label: 'Payment Links', to: '/payment-link-checkout' },
      { label: 'SEO', to: '/services/seo' },
      { label: 'Paid Advertising', to: '/services/paid-advertisement' },
      { label: 'Content Marketing', to: '/services/content-marketing' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'support@a1xpay.com', to: '/contact-us' },
      { label: 'Contact Us', to: '/contact-us' },
      { label: 'Privacy Policy', to: '/privacy-policy' },
      { label: 'Terms & Conditions', to: '/terms-conditions' },
    ],
  },
]

const socials = [
  { icon: <Facebook size={14} />, href: '#' },
  { icon: <Twitter size={14} />, href: '#' },
  { icon: <Linkedin size={14} />, href: '#' },
  { icon: <Instagram size={14} />, href: '#' },
]

export default function Footer() {
  const [email, setEmail] = useState('')

  return (
    <>
      <style>{css}</style>
      <footer className="ft-root">
        {/* Footer illustrations */}
        <div className="ft-illu-wrap">
          <img src={`${B}/footer-Illu-left.png`} className="ft-illu ft-illu-l" alt="" />
          <img src={`${B}/footer-Illu-right.png`} className="ft-illu ft-illu-r" alt="" />
        </div>

        <div className="ft-container">
          {/* Top get-started strip */}
          <div className="ft-top-strip">
            <div className="ft-top-text">
              <p className="ft-top-sub">Ready to get started?</p>
              <h3 className="ft-top-title">It only takes a few minutes to register your FREE A1XPAY account.</h3>
            </div>
            <Link to="/register" className="ft-cta-btn">Open an Account</Link>
          </div>

          <div className="ft-divider" />

          {/* Brand */}
          <div className="ft-brand-row">
            <Link to="/" className="ft-brand">
              <span className="ft-logo">
                <span className="ft-logo-a">A</span><span className="ft-logo-1">1</span><span className="ft-logo-x">X</span><span className="ft-logo-pay">PAY</span>
              </span>
            </Link>
            <p className="ft-brand-desc">
              A modern, technology-first payment platform built for you and your growing business.
            </p>
            <div className="ft-socials">
              {socials.map((s, i) => (
                <a key={i} href={s.href} className="ft-social">{s.icon}</a>
              ))}
            </div>
          </div>

          {/* Links + Subscribe */}
          <div className="ft-main-row">
            {cols.map((col) => (
              <div key={col.title} className="ft-col">
                <h5 className="ft-col-title">{col.title}</h5>
                <ul className="ft-col-links">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link to={l.to} className="ft-col-link">{l.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="ft-col">
              <h5 className="ft-col-title">Subscribe</h5>
              <div className="ft-subscribe">
                <input
                  type="email"
                  className="ft-email-input"
                  placeholder="Enter Your Email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button className="ft-subscribe-btn">Subscribe</button>
              </div>
              <p className="ft-sub-note">Get the latest updates via email. Any time you may unsubscribe</p>
            </div>
          </div>

          <div className="ft-divider" />

          {/* Bottom bar */}
          <div className="ft-bottom">
            <span className="ft-copy">Copyright © {new Date().getFullYear()} A1XPAY. All rights reserved.</span>
            <div className="ft-bottom-links">
              <Link to="/privacy-policy" className="ft-bottom-link">Privacy</Link>
              <Link to="/terms-conditions" className="ft-bottom-link">Terms &amp; Condition</Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

const css = `
.ft-root {
  background: #f5faff; position: relative; overflow: hidden;
  font-family: 'Jost', sans-serif; padding-top: 80px;
}
.ft-illu-wrap { position: absolute; inset: 0; pointer-events: none; }
.ft-illu { position: absolute; bottom: 100px; width: 12%; opacity: 0.6; }
.ft-illu-l { left: 0; }
.ft-illu-r { right: 0; }

.ft-container { max-width: 1200px; margin: 0 auto; padding: 0 1.5rem 0; position: relative; z-index: 2; }
@media (min-width:1200px) { .ft-container { padding: 0 2.5rem; } }

/* Top strip */
.ft-top-strip {
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 1.5rem;
  background: #1A4DBE; border-radius: 1.25rem; padding: 2.5rem 3rem;
  margin-bottom: 3.5rem;
}
.ft-top-sub { font-size: 0.875rem; font-weight: 600; color: rgba(255,255,255,0.7); text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 0.4rem; }
.ft-top-title { font-size: 1.375rem; font-weight: 700; color: #fff; max-width: 500px; line-height: 1.35; margin: 0; }
.ft-cta-btn {
  display: inline-flex; align-items: center; padding: 0.7rem 1.75rem;
  background: #fff; color: #1A4DBE; font-size: 0.9375rem; font-weight: 700;
  border-radius: 50px; text-decoration: none; white-space: nowrap;
  transition: transform 0.15s, box-shadow 0.15s;
  box-shadow: 0 4px 14px rgba(0,0,0,0.12);
}
.ft-cta-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(0,0,0,0.15); }

.ft-divider { height: 1px; background: rgba(44,54,85,0.12); margin: 2rem 0; }

/* Brand */
.ft-brand-row { display: flex; align-items: flex-start; gap: 1.25rem; flex-wrap: wrap; flex-direction: column; margin-bottom: 2.5rem; }
.ft-brand { display: flex; align-items: center; text-decoration: none; }
.ft-logo {
  display: inline-flex; align-items: baseline;
  font-size: 1.5rem; font-weight: 900; letter-spacing: -0.04em; line-height: 1;
  font-family: 'Jost', sans-serif;
}
.ft-logo-a {
  background: linear-gradient(170deg, #4A5568 0%, #1A202C 40%, #4A5568 100%);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
}
.ft-logo-1 {
  background: linear-gradient(170deg, #FCD34D 0%, #F59E0B 50%, #B45309 100%);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
}
.ft-logo-x {
  background: linear-gradient(170deg, #4A5568 0%, #1A202C 40%, #4A5568 100%);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
}
.ft-logo-pay {
  background: linear-gradient(135deg, #1A4DBE 0%, #3B82F6 60%, #06B6D4 100%);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
}
.ft-brand-desc { font-size: 0.9rem; color: #2C3655; line-height: 1.65; max-width: 340px; }
.ft-socials { display: flex; gap: 0.5rem; }
.ft-social {
  width: 2rem; height: 2rem; border-radius: 50%; display: flex; align-items: center; justify-content: center;
  color: #1A4DBE; border: 1px solid #B0BAF1; text-decoration: none;
  transition: background 0.15s, color 0.15s;
}
.ft-social:hover { background: #1A4DBE; color: #fff; border-color: #1A4DBE; }

/* Main link columns */
.ft-main-row {
  display: grid; grid-template-columns: 1fr; gap: 2rem;
  margin-bottom: 1rem;
}
@media (min-width:640px) { .ft-main-row { grid-template-columns: repeat(2,1fr); } }
@media (min-width:1024px) { .ft-main-row { grid-template-columns: repeat(4,1fr); } }

.ft-col {}
.ft-col-title { font-size: 1rem; font-weight: 700; color: #0A1023; margin-bottom: 1rem; }
.ft-col-links { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 0.5rem; }
.ft-col-link { font-size: 0.9rem; color: #2C3655; text-decoration: none; transition: color 0.15s; }
.ft-col-link:hover { color: #1A4DBE; }

/* Subscribe */
.ft-subscribe { display: flex; flex-direction: column; gap: 0.5rem; margin-bottom: 0.625rem; }
.ft-email-input {
  padding: 0.625rem 1rem; border: 1px solid #D8DFEE; border-radius: 0.5rem;
  font-size: 0.875rem; font-family: 'Jost', sans-serif; color: #0A1023;
  background: #fff; outline: none; transition: border-color 0.15s;
  width: 100%; height: auto;
}
.ft-email-input:focus { border-color: #1A4DBE; }
.ft-subscribe-btn {
  padding: 0.625rem 1.25rem; background: #1A4DBE; color: #fff;
  border: none; border-radius: 0.5rem; font-size: 0.875rem; font-weight: 600;
  font-family: 'Jost', sans-serif; cursor: pointer; transition: background 0.15s;
}
.ft-subscribe-btn:hover { background: #1540a8; }
.ft-sub-note { font-size: 0.8rem; color: #4a4a6a; line-height: 1.5; }

/* Bottom */
.ft-bottom {
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 0.875rem;
  padding: 1.25rem 0;
}
.ft-copy { font-size: 0.875rem; color: #2C3655; }
.ft-bottom-links { display: flex; gap: 1.5rem; }
.ft-bottom-link { font-size: 0.875rem; color: #2C3655; text-decoration: none; transition: color 0.15s; }
.ft-bottom-link:hover { color: #1A4DBE; }
`
